import React from 'react'
import styled, { keyframes } from 'styled-components';
import images from '../../assets/images/adam.jpeg'
import baground from '../../assets/images/baground.jpg'
import {Link} from 'react-router-dom'
import { url } from '../../App';

const Wrapper = styled.div`
    display:flex;
    height:65vh;
    width:100%;
    z-index:999;
    overflow-x:visible;
    padding:220px 80px 0 80px;
    justify-content: space-between;
    align-items:center;
    background: #4a55da;
    /* background:#5c5bf3; */
    @media screen and (max-width: 800px){
        flex-direction:column-reverse;
        padding:140px 20px 0 20px;
        height:84vh;

    }
`
const WrappTitle = styled.div`
    width:50%;
    display:flex;
    position:relative;
    flex-direction:column;
    @media screen and (max-width: 800px){
        width:100%;
        justify-content: center;
        align-items: center;
    }
    
`
const Img = styled.img`
    width:300px;
    height:300px;
    object-fit:cover;
    z-index:9999;
    border:4px solid white;
    /* border-radius: 20px; */
    border-radius: 100%;
  
    
    @media screen and (max-width: 800px){
        width:250px;
        height:250px;
        border-radius: 100%;
    }
`

const Title = styled.h1`
    font-family: 'Source Code Pro', monospace;
    color:#fff;
    font-size:2em;
    /* float: left; */
     line-height:1.4em;
    margin-bottom:50px;
    @media screen and (max-width: 990px){
        font-size:1.5em;
    }
    @media screen and (max-width: 800px){
        font-size:1.2em;
        width:100%;
        margin-bottom:30px;
        text-align: center;
    }
`
const ButtonCv = styled.button`
    text-decoration:none;
    width:200px;
    height:50px;
    position:relative;
    font-size:1.4em;
    text-align:center;
    font-weight:bold;
    outline:none;
    border:none;
    padding:8px;
    color: #fff;
    border-radius:2px;
    background:#F9A826; 
    cursor: pointer;
    transition: .4s ease-in;
    box-shadow:0 2px 2px 0 rgba(0,0,0,0.4);
    &:hover{
        transform: scaleX(1.1);
    }
   
    @media (max-width:800px){
    font-size:1em;
    z-index:9;
    background:#F9A826;
    color: #fff;
    height:40px;
    }
`


const A = styled(Link)`
    text-decoration:none;
`
function Profile (){
    
    return(
        <>
    
            <Wrapper>
                <WrappTitle>
                    <Title>Hi, my name is Adam dwi maulana I Web Developer based on Bekasi,  Indonesia 
                    </Title>
                    <a href="#" target="_blank" rel="noreferer">
                    <ButtonCv>Download CV</ButtonCv>
                    </a>
                </WrappTitle>
                    <Img src={images}  alt='foto' />
            </Wrapper>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#4a55da" fillOpacity="1" d="M0,96L26.7,90.7C53.3,85,107,75,160,85.3C213.3,96,267,128,320,160C373.3,192,427,224,480,218.7C533.3,213,587,171,640,176C693.3,181,747,235,800,240C853.3,245,907,203,960,165.3C1013.3,128,1067,96,1120,106.7C1173.3,117,1227,171,1280,186.7C1333.3,203,1387,181,1413,170.7L1440,160L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z"></path></svg>
           
                
        </>
    )
}
export default Profile;